// secureStorage.js — Wrapper for client-side storage with basic encoding + error logging
// Tokens should use httpOnly cookies when auth is implemented

const PREFIX = "gm_";

function encode(value) {
  try {
    return btoa(unescape(encodeURIComponent(value)));
  } catch {
    return value;
  }
}

function decode(value) {
  try {
    return decodeURIComponent(escape(atob(value)));
  } catch {
    return value;
  }
}

export const secureStorage = {
  getItem(key) {
    try {
      const raw = sessionStorage.getItem(PREFIX + key);
      if (raw) return decode(raw);
      // Fallback: migrate from old localStorage
      const legacy = localStorage.getItem(key);
      if (legacy) {
        sessionStorage.setItem(PREFIX + key, encode(legacy));
        localStorage.removeItem(key);
        return legacy;
      }
      return null;
    } catch (e) {
      console.error(`[secureStorage] getItem(${key}):`, e);
      return null;
    }
  },
  setItem(key, value) {
    try {
      sessionStorage.setItem(PREFIX + key, encode(value));
    } catch (e) {
      console.error(`[secureStorage] setItem(${key}):`, e);
    }
  },
  removeItem(key) {
    try {
      sessionStorage.removeItem(PREFIX + key);
      localStorage.removeItem(key); // also clean legacy
    } catch (e) {
      console.error(`[secureStorage] removeItem(${key}):`, e);
    }
  },
};

// Persistent storage for preferences (non-sensitive, survives tabs)
export const prefStorage = {
  getItem(key) {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      console.error(`[prefStorage] getItem(${key}):`, e);
      return null;
    }
  },
  setItem(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (e) {
      console.error(`[prefStorage] setItem(${key}):`, e);
    }
  },
  removeItem(key) {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      console.error(`[prefStorage] removeItem(${key}):`, e);
    }
  },
};
